export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/fortisimo-icon.svg?cd52fbd6408a9f4f0b25374cad804a27";